var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.846 40.0997L46.7838 33.9885H40.9201V30.0228C40.9201 28.351 41.7392 26.7213 44.3654 26.7213H47.0312V21.5183C47.0312 21.5183 44.6121 21.1055 42.2991 21.1055C37.4701 21.1055 34.3136 24.0324 34.3136 29.331V33.9885H28.9458V40.0997H34.3136V54.8729H40.9201V40.0997H45.846Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.7675,
    height: 33.7675,
    fill: "white",
    transform: "translate(21.1045 21.1045)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbicon);
export default __webpack_public_path__ + "static/media/fbicon.eecd116d11f006211dc731e33ab07456.svg";
export { ForwardRef as ReactComponent };